import React, { useEffect, useRef, useState } from "react"
import "../styles/resultstage.css"
import { RaceDTO } from "../../../interfaces/RaceDTO";
import { SprintStageDTO } from "../../../interfaces/ClassesDTO";
import ResultTable from "./ResultTable";
import { ViewType } from "../../../interfaces/internal/ViewProps";
import moment from "moment";
import { eventBus } from "../../../services/eventHandler";
import ResultStageHeader from "./ResultStageHeader";
import ResultStageBox from "./ResultStageBox";
interface Props {
    race: RaceDTO;
    classid: number | null;
    vwindPropId:number;
}
export function GetHeatName(heat:number):string{
switch(heat) { 
   case 3: { 
      return "Quarterfinal-1" 
   } 
   case 4: { 
    return "Quarterfinal-2" 
   } 
   case 5: { 
    return "Quarterfinal-3" 
   } 
   case 6: { 
    return "Quarterfinal-4" 
   } 
   case 11: { 
    return "Quarterfinal-5" 
   } 
   case 7: { 
    return "Semifinal-1" 
   } 
   case 8: { 
    return "Semifinal-2" 
   } 
   case 10: { 
    return "A-Final" 
   } 
   case 9: { 
    return "B-Final" 
   } 
   case 501: { 
    return "1/16-heat 1" 
   } 
   case 502: { 
    return "1/16-heat 2" 
   } 
   case 503: { 
    return "1/16-heat 3" 
   } 
   case 504: { 
    return "1/16-heat 4" 
   } 
   case 505: { 
    return "1/16-heat 5" 
   } 
   case 506: { 
    return "1/16-heat 6" 
   } 
   case 507: { 
    return "1/16-heat 7" 
   } 
   case 508: { 
    return "1/16-heat 8" 
   } 
   case 509: { 
    return "1/16-heat 9" 
   } 
   case 510: { 
    return "1/16-heat 10" 
   } 
   case 511: { 
    return "1/16-heat 11" 
   } 
   case 512: { 
    return "1/16-heat 12" 
   } 
   case 513: { 
    return "1/16-heat 13" 
   } 
   case 514: { 
    return "1/16-heat 14" 
   } 
   case 515: { 
    return "1/16-heat 15" 
   } 
   case 516: { 
    return "1/16-heat 16" 
   } 
   case 41: { 
    return "1/8-heat 1" 
   } 
   case 42: { 
    return "1/8-heat 2" 
   } 
   case 43: { 
    return "1/8-heat 3" 
   } 
   case 44: { 
    return "1/8-heat 4" 
   } 
   case 45: { 
    return "1/8-heat 5" 
   } 
   case 46: { 
    return "1/8-heat 6" 
   } 
   case 47: { 
    return "1/8-heat 7" 
   } 
   case 48: { 
    return "1/8-heat 8" 
   } 
}
    return "undefined";
}
const ResultStage = ({race,classid,vwindPropId} : Props) => {
    const [stageType,setStageType] = useState<SprintStageDTO | null>();
    const [sprintHeats,setSprintHeat] = useState<number[] |[]>([]);
    const [activeLevel,setActiveLevel] = useState<number>(0);
    const curentClassid = useRef(classid);
    useEffect(() => {
        if (classid !== null){
            // setStageType(race?.Class[classid].StageType!);
            setStageType(race.Class[classid].StageType);
        }
        setActiveLevel(0);
    },[classid]);
    useEffect(() => {
        const handlerActive = (clsId:number,lvl:number) => {
            console.log(clsId,lvl,curentClassid.current);
            if (clsId === curentClassid.current){
                setActiveLevel(lvl);
            }
            else{
                setActiveLevel(0);
            }
        };

        eventBus.on(
            `active_level`,
            handlerActive
          );
        return () => {
            eventBus.removeListener(
                `active_level`,
                handlerActive
              );
        }
    },[])
    useEffect(() => {
        if (stageType != null){
            if (stageType === SprintStageDTO.onTime30){
                setSprintHeat([3,4,5,6,11,7,8,10]);
            }
            else if (stageType === SprintStageDTO.onTime30bFinal)
            {
                setSprintHeat([3,4,5,6,11,7,8,9,10]);
            }
            else if (stageType === SprintStageDTO.onTime16bFinal || stageType === SprintStageDTO.onTime16 || stageType === SprintStageDTO.noTime16)
            {
                setSprintHeat([3,4,5,6,7,8,10]);
            }
            else if (stageType === SprintStageDTO.Super32)
            {
                setSprintHeat([3,4,5,6,7,8,9,10,41,42,43,44,45,46,47,48,501,502,503,504,505,506,507,508,509,510,511,512,513,514,515,516]);
            }
            console.log("Stagetype***",stageType);
            // else if (stageType === SprintStageDTO.onTime16)
            //     {
            //         setSprintHeat([3,4,5,6,7,8,10]);
            //     }
        }
        // setSprintHeat([3,4,5,6,7,8,9,10,41,42,43,44,45,46,47,48,501,502,503,504,505,506,507,508,509,510,511,512,513,514,515,516]);

    },[stageType]);

    return (<div className="result-stage">
        <div className={"result-stage-innner"} data-stage-heat={stageType}>
            {sprintHeats.map((heat) => (
               <ResultStageBox  key={heat + "-" + classid}  race={race} level={heat} classid={classid} activeLevel={activeLevel} vwindPropId={vwindPropId} />
            ))}
            </div>
    </div>)
}
export default ResultStage;